module.exports = __webpack_public_path__ + "static/media/investNavLogoNew.0ab4b981.svg";